import type { PageConfig } from '../types';

export const lookingAheadPageConfig: PageConfig = {
  id: 'looking-ahead',
  tabLabel: 'Looking ahead',
  sections: [
    {
      id: 'narrative',
      titleFromMetric: true,
      layout: 'grid-1',
      items: [{ kind: 'insight', id: 'monthly_focus_narrative', span: 'full' }],
    },
    {
      id: 'focus-models',
      overline: 'FOCUS MODELS FOR MAY',
      aside: 'Pulled from your commercial priorities',
      layout: 'grid-4',
      items: [
        { kind: 'metric', id: 'focus_model_nurturing_pool_count' },
        { kind: 'metric', id: 'focus_models_nurturing_pool_share' },
        { kind: 'metric', id: 'model_performance_status' },
        { kind: 'metric', id: 'inventory_aged_unit_count' },
      ],
    },
    {
      id: 'inventory-watchlist',
      overline: 'INVENTORY WATCHLIST',
      titleFromMetric: true,
      layout: 'grid-1',
      items: [{ kind: 'insight', id: 'inventory_watchlist', span: 'full' }],
    },
    {
      id: 'discussion-items',
      overline: 'FOR YOUR NEXT CHECK-IN',
      titleFromMetric: true,
      action: { label: 'Share with team' },
      layout: 'grid-1',
      items: [{ kind: 'insight', id: 'discussion_item_packet', span: 'full' }],
    },
  ],
};
